/* RC29: BOGO gift reconciliation. Classic script; shares JC's cart queue and Horizon events. */
(function (root, factory) {
  var api = factory();
  root.JcPromo = api;
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (root.document) api.start(root);
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var has = function (object, key) { return Object.prototype.hasOwnProperty.call(object, key); };
  function valid(config) {
    return !!(config && config.v === 1 && config.property === '_jc_bogo' &&
      typeof config.endsAt === 'string' && Number.isFinite(Date.parse(config.endsAt)) &&
      Array.isArray(config.tiers) && config.tiers.length && config.tiers.every(function (tier) {
        return tier && Number.isSafeInteger(tier.tier) && tier.tier > 0 &&
          (typeof tier.variantId === 'string' || typeof tier.variantId === 'number') &&
          /^\d+$/.test(String(tier.variantId)) && Number.isSafeInteger(Number(tier.variantId)) && Number(tier.variantId) > 0 &&
          Number.isSafeInteger(tier.qty) && tier.qty > 0 && Array.isArray(tier.handles) &&
          tier.handles.length && tier.handles.every(function (handle) { return typeof handle === 'string' && !!handle; });
      }));
  }
  function active(config) { return valid(config) && config.active !== false && Date.now() < Date.parse(config.endsAt); }
  function counts(cart, config) {
    var result = Object.create(null), highestTier = 0;
    if (config.oneTierPerOrder === true) {
      ((cart && cart.items) || []).forEach(function (item) {
        var quantity = Number(item.quantity);
        if (!Number.isSafeInteger(quantity) || quantity <= 0 ||
          (item.properties && has(item.properties, config.property))) return;
        config.tiers.forEach(function (tier) {
          if (tier.handles.indexOf(item.handle) >= 0) highestTier = Math.max(highestTier, tier.tier);
        });
      });
    }
    function entry(id) {
      return result[id] || (result[id] = { required: 0, present: 0, tier: Infinity, lines: [] });
    }
    config.tiers.forEach(function (tier) { entry(String(tier.variantId)); });
    ((cart && cart.items) || []).forEach(function (item) {
      var quantity = Number(item.quantity);
      if (!Number.isSafeInteger(quantity) || quantity <= 0) return;
      if (item.properties && has(item.properties, config.property)) {
        var gift = entry(String(item.variant_id));
        gift.present += quantity; gift.lines.push(item);
        return;
      }
      config.tiers.forEach(function (tier) {
        if ((config.oneTierPerOrder === true && tier.tier !== highestTier) || tier.handles.indexOf(item.handle) < 0) return;
        var gift = entry(String(tier.variantId));
        gift.required += quantity * tier.qty;
        gift.tier = Math.min(gift.tier, tier.tier);
      });
    });
    return result;
  }
  // Pure state transition: lastPresent comes from server snapshots/acknowledged writes.
  function observe(cart, config, state) {
    state = state || {};
    var declined = Object.assign({}, state.declined || {}), lastPresent = {};
    var suppressed = Object.assign({}, state.suppressed || {});
    if (!valid(config)) return { declined: declined, lastPresent: lastPresent, suppressed: suppressed };
    var totals = counts(cart, config);
    Object.keys(declined).forEach(function (id) { if (!totals[id] || !totals[id].required) delete declined[id]; });
    Object.keys(suppressed).forEach(function (id) { if (!totals[id] || !totals[id].required) delete suppressed[id]; });
    Object.keys(totals).forEach(function (id) {
      var gift = totals[id];
      if (gift.required >= gift.present && gift.lines.some(function (line) { return Number(line.final_line_price) > 0; })) suppressed[id] = true;
      if (!gift.required) delete declined[id];
      lastPresent[id] = gift.present;
    });
    return { declined: declined, lastPresent: lastPresent, suppressed: suppressed };
  }
  function plan(cart, config, state) {
    if (!valid(config) || !cart || !Array.isArray(cart.items)) return [];
    var next = observe(cart, config, state), totals = counts(cart, config), actions = [];
    Object.keys(totals).forEach(function (id) {
      var gift = totals[id], required = active(config) ? gift.required : 0;
      var paid = gift.lines.filter(function (item) { return Number(item.final_line_price) > 0; });
      var present = gift.present - paid.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      paid.forEach(function (item) { actions.push({ type: 'change', key: item.key, quantity: 0 }); });
      var excess = present - required;
      // Shopify returns most recently added lines first. Keys, never line numbers, identify writes.
      gift.lines.forEach(function (item) {
        if (excess <= 0 || paid.indexOf(item) >= 0) return;
        var remove = Math.min(excess, item.quantity);
        actions.push({ type: 'change', key: item.key, quantity: item.quantity - remove });
        excess -= remove;
      });
      if (required > present && !next.declined[id] && !next.suppressed[id]) {
        actions.push({ type: 'add', variantId: id, quantity: required - present, tier: gift.tier });
      }
    });
    return actions.filter(function (action) { return action.type !== 'add'; })
      .concat(actions.filter(function (action) { return action.type === 'add'; }));
  }
  function start(win, loadEvents) {
    var doc = win.document, config, cartConfig;
    var nonce = doc.currentScript && doc.currentScript.nonce;
    try {
      if (win.Shopify && win.Shopify.designMode) return;
      var node = doc.getElementById('jc-promo-config');
      if (!node) return;
      config = JSON.parse(node.textContent);
      if (!valid(config)) return;
      cartConfig = JSON.parse(doc.getElementById('jc-cart-config').textContent);
      if (cartConfig.designMode) return;
    } catch (_) { return; }
    var state = { declined: {}, lastPresent: {}, suppressed: {} }, timer, running = false, pending = false;
    var warned = false, history = [], stopped = false, signature = null, ownEvents = new WeakSet();
    var cleanupFailures = 0, cleanupBefore = null; // Only consecutive unverified safety removals consume the budget.
    var events, api, attempts = 0, restoreButtons = new Set(), restoreRequested = false;
    try {
      var stored = JSON.parse(win.sessionStorage.getItem('jc_bogo_declined') || '{}');
      if (stored && typeof stored === 'object' && !Array.isArray(stored)) {
        Object.keys(stored).forEach(function (id) { if (stored[id] === true) state.declined[id] = true; });
      }
    } catch (_) {}
    ['lastPresent', 'suppressed'].forEach(function (key) {
      try {
        var value = JSON.parse(win.sessionStorage.getItem('jc_bogo_' + key) || '{}');
        if (value && typeof value === 'object' && !Array.isArray(value)) state[key] = value;
      } catch (_) {}
    });
    function save() {
      ['declined', 'lastPresent', 'suppressed'].forEach(function (key) {
        try { win.sessionStorage.setItem('jc_bogo_' + key, JSON.stringify(state[key])); } catch (_) {}
      });
    }
    // Persist explicit intent before Horizon's remove handler or a navigation can run.
    doc.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('.cart-items__remove');
      var row = button && button.closest('tr[data-jc-promo-gift]');
      var id = row && row.getAttribute('data-jc-promo-gift');
      if (id) { state.declined[id] = true; save(); }
    }, true);
    var task = null, flushTask = null, flushing = false;
    win.JcPromo = win.JcPromo || {};
    win.JcPromo.flush = function () {
      if (flushTask) return flushTask;
      flushTask = new Promise(function (resolve) {
        var done = false, timeout = win.setTimeout(finish, 4000);
        function finish() {
          if (done) return;
          done = true; win.clearTimeout(timeout); flushing = false; resolve();
        }
        (async function () {
          flushing = true;
          while (!done && (!api || !events)) await new Promise(function (next) { win.setTimeout(next, 25); });
          for (var pass = 0; !done && pass < 32; pass++) {
            win.clearTimeout(timer);
            await sync();
            if (!pending && !restoreRequested) break;
          }
        })().then(finish, finish);
      }).then(function () { flushTask = null; });
      return flushTask;
    };
    function warn(error) {
      if (warned) return;
      warned = true;
      try { win.console.warn('JC promo sync failed', error); } catch (_) {}
    }
    function addError() {
      var live = doc.getElementById('jc-cart-live');
      if (live) live.textContent = config.strings && config.strings.addError || '';
    }
    function fingerprint(cart) {
      return JSON.stringify((cart.items || []).map(function (item) { return [item.key, item.quantity, item.final_line_price]; }));
    }
    function readDOM() {
      var node = doc.querySelector('#cart-drawer [data-jc-cart-state]') || doc.querySelector('[data-jc-cart-state]');
      try { return node ? JSON.parse(node.textContent) : null; } catch (_) { return null; }
    }
    function sections() {
      return Array.from(new Set(Array.from(doc.querySelectorAll('cart-items-component[data-section-id]'), function (el) { return el.dataset.sectionId; })));
    }
    async function read() {
      var response = await api.fetch(cartConfig.routes.cartJs, { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Promo cart read failed');
      return response.json();
    }
    async function post(route, body) {
      body.sections = sections(); body.sections_url = win.location.pathname;
      var response = await api.fetch(route, { method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      var result = await response.json();
      if (!response.ok || result.errors || result.status >= 400) throw new Error('Promo cart write failed');
      return result;
    }
    function publish(cart, rendered, didError) {
      // begin/finish are private in jc-cart.js. Publish a settled equivalent after owned writes;
      // announcing a pending external event inside its queue would invalidate ready() or deadlock it.
      var deferred = events.CartLinesUpdateEvent.createPromise();
      var event = new events.CartLinesUpdateEvent({ action: 'update', context: 'cart', lines: [], promise: deferred.promise });
      ownEvents.add(event);
      var source = doc.querySelector('#cart-drawer [data-jc-upsells]') || doc.querySelector('[data-jc-summary]') || doc.querySelector('cart-items-component .cart-form') || doc;
      source.dispatchEvent(event);
      deferred.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: {
        sections: rendered, items: cart.items, itemCount: cart.item_count, source: 'jc-cart', didError: !!didError
      } });
    }
    function releaseButtons() {
      restoreButtons.forEach(function (button) { button.disabled = false; button.removeAttribute('aria-busy'); });
      restoreButtons.clear();
    }
    function locked(exec) {
      if (win.navigator && win.navigator.locks && win.navigator.locks.request) {
        return win.navigator.locks.request('jc-promo-cart', exec);
      }
      return exec();
    }
    function safetyActions(cart) {
      var totals = counts(cart, config);
      return cart.items.filter(function (item) {
        return item.properties && has(item.properties, config.property) &&
          (Number(item.final_line_price) > 0 || !active(config) || !totals[String(item.variant_id)] || !totals[String(item.variant_id)].required);
      }).map(function (item) { return { type: 'change', key: item.key, quantity: 0 }; });
    }
    function verifyCleanup(cart) {
      var safety = safetyActions(cart);
      // A fresh read must prove completion or progress; a write response alone is insufficient.
      var quantity = safety.reduce(function (total, action) {
        return total + Number(cart.items.find(function (item) { return item.key === action.key; }).quantity);
      }, 0);
      if (!quantity || (cleanupBefore !== null && quantity < cleanupBefore)) cleanupFailures = 0;
      cleanupBefore = null; // Keep the outstanding baseline until a fresh read succeeds.
      return { actions: safety, quantity: quantity };
    }
    function sync() {
      if (task) { pending = true; return task; }
      task = performSync().finally(function () { task = null; });
      return task;
    }
    async function performSync() {
      if (running) { pending = true; return; }
      if (!api || !events) { releaseButtons(); return; }
      history = history.filter(function (time) { return Date.now() - time < 10000; });
      if (!flushing && history.length >= 4) stopped = true;
      var normalAllowed = flushing || !stopped;
      if (normalAllowed) history.push(Date.now());
      running = true; pending = false;
      var wrote = false, adding = false, cleanupNeeded = false;
      try {
        var reconcile = function (cleanupOnly) { return api.queue.run({ label: 'promo-sync', exec: async function (context) {
          var cart = await read();
          if (context.ready && !context.ready()) {
            var stale = new Error('Promo snapshot changed'); stale.jcStale = true; throw stale;
          }
          if (restoreRequested) {
            state = { declined: {}, lastPresent: {}, suppressed: state.suppressed }; restoreRequested = false; save();
          }
          var cleanup = verifyCleanup(cart), safety = cleanup.actions;
          var actions = safety.length ? (cleanupFailures < 3 ? safety : []) :
            (normalAllowed && !cleanupOnly ? plan(cart, config, state) : []);
          cleanupNeeded = false;
          state = observe(cart, config, state); save(); signature = fingerprint(cart);
          if (!actions.length) return;
          var changes = actions.filter(function (action) { return action.type === 'change'; });
          var adds = actions.filter(function (action) { return action.type === 'add'; });
          var result;
          // One mutation per queue job. A further reduction/add needs another settled
          // snapshot, since native/vendor writes can intervene across any await.
          if (changes.length) {
            var change = changes[0];
            var line = cart.items.find(function (item) { return item.key === change.key; });
            if (safety.length) {
              cleanupBefore = cleanup.quantity;
              cleanupFailures++; // Retain the charge unless a fresh read verifies progress.
            }
            wrote = true;
            result = await post(cartConfig.routes.change, { id: change.key, quantity: change.quantity });
            state.lastPresent[String(line.variant_id)] -= line.quantity - change.quantity;
            pending = normalAllowed;
          } else if (adds.length) {
            adding = true; wrote = true;
            result = await post(cartConfig.routes.add, { items: adds.map(function (action) {
              var properties = {}; properties[config.property] = String(action.tier);
              return { id: action.variantId, quantity: action.quantity, properties: properties };
            }) });
            adding = false;
            var acknowledged = counts({ items: result.items || [] }, config);
            adds.forEach(function (action) {
              var gift = acknowledged[action.variantId];
              if (gift) state.lastPresent[action.variantId] = Math.max(state.lastPresent[action.variantId], gift.present);
            });
          }
          cart = await read();
          state = observe(cart, config, state); save();
          cleanupNeeded = verifyCleanup(cart).actions.length > 0 && cleanupFailures < 3;
          // Own events/signatures must not hide a still-incorrect server cart.
          pending = normalAllowed && plan(cart, config, state).length > 0;
          signature = fingerprint(cart);
          publish(cart, result.sections, false);
        } }); };
        await locked(async function () {
          await reconcile();
          // Successful safety removals can drain fragmented lines; only failures are bounded.
          while (cleanupNeeded && cleanupFailures < 3) await reconcile(true);
        });
      } catch (error) {
        if (adding) addError();
        warn(error);
        if (wrote) {
          try {
            await locked(async function () {
              var current = await read();
              state = observe(current, config, state); save();
              pending = normalAllowed && plan(current, config, state).some(function (action) { return action.type === 'change'; });
              cleanupNeeded = verifyCleanup(current).actions.length > 0 && cleanupFailures < 3;
              signature = fingerprint(current); publish(current, undefined, true);
              // Recovery can discover unsafe lines even on the fourth normal pass.
              while (cleanupNeeded && cleanupFailures < 3) await reconcile(true);
            });
          } catch (_) {}
        }
      } finally {
        running = false;
        if (!pending && !restoreRequested) releaseButtons();
        if (!flushing && (pending || restoreRequested)) schedule();
      }
    }
    function schedule() {
      if (running) { pending = true; return; }
      win.clearTimeout(timer); timer = win.setTimeout(function () { sync().catch(warn); }, 300);
    }
    function changed() {
      var cart = readDOM();
      if (cart && fingerprint(cart) !== signature) schedule();
    }
    function shopper(event) {
      if (!event.isTrusted || !event.target.closest) return;
      if (event.target.closest('cart-items-component, product-form-component, [data-jc-promo-restore], #shippingProtectionCheckBox')) {
        stopped = false; // Keep the rolling limit; only a new shopper action unlocks it.
        history = [];
        cleanupFailures = 0; cleanupBefore = null;
      }
    }
    function eventModule() {
      // Keep this asset an ES2019 classic script. A small static-import module
      // bridge reuses Horizon's class without eval or ES2020 import() syntax.
      return new Promise(function (resolve, reject) {
        var bridge = doc.createElement('script');
        var name = 'jc-promo-events-' + Date.now() + '-' + Math.random().toString(36).slice(2);
        var timeout = win.setTimeout(function () { done(new Error('Promo events unavailable')); }, 10000);
        function received(event) { done(null, event.detail); }
        function done(error, module) {
          win.clearTimeout(timeout); doc.removeEventListener(name, received); bridge.remove();
          if (error) reject(error); else resolve(module);
        }
        doc.addEventListener(name, received, { once: true });
        bridge.type = 'module';
        if (nonce) bridge.nonce = nonce;
        bridge.textContent = "import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';" +
          'document.dispatchEvent(new CustomEvent(' + JSON.stringify(name) +
          ', {detail: {CartLinesUpdateEvent, StandardEvents}}));';
        bridge.addEventListener('error', function () { done(new Error('Promo events load failed')); }, { once: true });
        (doc.head || doc.documentElement).appendChild(bridge);
      });
    }
    function boot() {
      if (!valid(config)) return;
      api = win.JcCart;
      if (!api || !api.queue || !api.fetch) {
        if (++attempts < 100) win.setTimeout(boot, 100);
        return;
      }
      Promise.resolve().then(function () { return loadEvents ? loadEvents() : eventModule(); }).then(function (module) {
        events = module;
        doc.addEventListener(events.StandardEvents.cartLinesUpdate, function (event) {
          if (ownEvents.has(event)) return;
          if (event.promise) Promise.resolve(event.promise).then(schedule, schedule);
          else schedule();
        });
        function containsState(node) {
          return node.nodeType === 1 && (node.matches('[data-jc-cart-state]') || node.querySelector('[data-jc-cart-state]'));
        }
        var observer = new win.MutationObserver(function (records) {
          if (records.some(function (record) {
            var parent = record.target.nodeType === 1 ? record.target : record.target.parentElement;
            return (parent && parent.closest('[data-jc-cart-state]')) ||
              Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(containsState);
          })) changed();
        });
        observer.observe(doc.documentElement, { childList: true, characterData: true, subtree: true });
        ['click', 'change', 'input', 'submit'].forEach(function (name) { doc.addEventListener(name, shopper, true); });
        doc.addEventListener('click', function (event) {
          var button = event.target.closest && event.target.closest('[data-jc-promo-restore]');
          if (!button || button.disabled) return;
          event.preventDefault(); button.disabled = true; button.setAttribute('aria-busy', 'true'); restoreButtons.add(button);
          state = { declined: {}, lastPresent: {}, suppressed: state.suppressed }; save(); restoreRequested = true;
          stopped = false; history = []; schedule();
        });
        var cart = readDOM();
        if (!cart || (cart.items && cart.items.length)) schedule();
      }).catch(warn);
    }
    boot();
  }
  return { plan: plan, observe: observe, start: start, flush: function () { return Promise.resolve(); } };
});
